import React, { Component } from 'react';
import stickybits from 'stickybits';

import EraHero from './EraHero';
import ContentGrid from '../global/ContentGrid';
import QuoteBanner from './QuoteBanner';

import style from '../../templates/Timeline.module.scss';

class Era extends Component {
  state = {
    inViewport: false,
  };

  componentDidMount() {
    stickybits('.era-watermark', {
      stickyBitStickyOffset: 300,
    });
    // console.log('did mount', this.props.index);
    this.props.getIsMountedIndex(this.props.index);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.inView !== this.props.inView &&
      this.props.inView &&
      !this.state.inViewport
    ) {
      this.setState({ inViewport: true });
      this.props.getInViewIndex(this.props.index);
    }
  }

  render() {
    const { lastHeader, goToAbout } = this.props;

    return (
      <React.Fragment>
        <div className={`era-watermark ${style.eraWatermark}`}>
          {this.props.data.starting_year}-{this.props.data.ending_year}
        </div>
        <EraHero {...this.props.data} />
        {this.props.data.era_content &&
          this.props.data.era_content.map((content, i) => {
            switch (content.era_type) {
              case 'content_grid':
                return (
                  <ContentGrid
                    eraInView={this.props.inLoadedArray}
                    key={`${this.props.data.starting_year}${i}`}
                    {...content}
                  />
                );
              case 'quote_banner':
                return (
                  <QuoteBanner
                    eraInView={this.props.inLoadedArray}
                    key={`${this.props.data.starting_year}${i}`}
                    {...content}
                  />
                );
              default:
                return '';
            }
          })}
        {lastHeader !== null && (
          <EraHero last {...lastHeader} goToAbout={goToAbout} />
        )}
      </React.Fragment>
    );
  }
}

export default Era;



// WEBPACK FOOTER //
// ./src/components/timeline/Era.js